import { useState } from "react";
export const useZoomPan = (minZoom = 0.5, maxZoom = 5) => {
    const [scale, setScale] = useState(1);
    const [position, setPosition] = useState({
        x: 0,
        y: 0,
    });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({
        x: 0,
        y: 0,
    });
    const [lastTouchDistance, setLastTouchDistance] = useState(null);
    const getDistance = (t1, t2) => Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
    const handleMouseDown = (e) => {
        setIsDragging(true);
        setDragStart({
            x: e.clientX - position.x,
            y: e.clientY - position.y,
        });
    };
    const handleMouseMove = (e) => {
        if (!isDragging)
            return;
        setPosition({
            x: e.clientX - dragStart.x,
            y: e.clientY - dragStart.y,
        });
    };
    const handleMouseUp = () => {
        setIsDragging(false);
    };
    const handleTouchStart = (e) => {
        if (e.touches.length === 2) {
            e.preventDefault();
            setLastTouchDistance(getDistance(e.touches[0], e.touches[1]));
            setIsDragging(true);
            const midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
            const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
            setDragStart({
                x: midX - position.x,
                y: midY - position.y,
            });
        }
    };
    const handleTouchMove = (e, containerRef) => {
        if (e.touches.length === 2) {
            e.preventDefault();
            const midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
            const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
            if (isDragging) {
                setPosition({
                    x: midX - dragStart.x,
                    y: midY - dragStart.y,
                });
            }
            if (lastTouchDistance) {
                const newDist = getDistance(e.touches[0], e.touches[1]);
                const delta = (newDist - lastTouchDistance) * 0.002;
                const newScale = Math.min(Math.max(scale + delta, minZoom), maxZoom);
                const scaleRatio = newScale / scale;
                const container = containerRef.current;
                if (container) {
                    const rect = container.getBoundingClientRect();
                    const touchX = midX - rect.left;
                    const touchY = midY - rect.top;
                    setPosition((prev) => ({
                        x: touchX - scaleRatio * (touchX - prev.x),
                        y: touchY - scaleRatio * (touchY - prev.y),
                    }));
                }
                setScale(newScale);
                setLastTouchDistance(newDist);
            }
        }
    };
    const handleTouchEnd = () => {
        setIsDragging(false);
        setLastTouchDistance(null);
    };
    const handleWheel = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;
        const delta = e.deltaY * -0.001;
        const newScale = Math.min(Math.max(minZoom, scale + delta), maxZoom);
        const scaleRatio = newScale / scale;
        setPosition((prev) => ({
            x: mouseX - scaleRatio * (mouseX - prev.x),
            y: mouseY - scaleRatio * (mouseY - prev.y),
        }));
        setScale(newScale);
    };
    const resetZoom = () => {
        setScale(1);
        setPosition({ x: 0, y: 0 });
    };
    return {
        scale,
        position,
        isDragging,
        handleMouseDown,
        handleMouseMove,
        handleMouseUp,
        handleTouchStart,
        handleTouchMove,
        handleTouchEnd,
        handleWheel,
        resetZoom,
    };
};
